import moment from "moment";

export const createDateAsUTC = (date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()))
}

export const convertTime12to24 = (time12h) => {
  if(!time12h || (time12h.toLowerCase().indexOf('am') === -1 && time12h.toLowerCase().indexOf('pm') === -1) ) {
    return time12h
  }

  const modifier = time12h.toLowerCase().indexOf('am') === -1 ? 'PM' : 'AM';

  const time = time12h.replace(/[^\d:]/gmi, '')

  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12;
  }

  return `${hours.toString().padStart(2,'0')}:${minutes}`;
}

export const convertTime24To12 = (time24h) => {
  // Check correct time format and split into components
  time24h = time24h.toString().match(/^([0-2]?\d)(:)([0-5]\d)(:[0-5]\d)?$/) || [time24h];

  if (time24h.length > 1) { // If time format correct
    time24h = time24h.slice(1); // Remove full string match value
    time24h[5] = +time24h[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time24h[0] = +time24h[0] % 12 || 12; // Adjust hours
    time24h[0] = time24h[0].toString().padStart(2,'0');
  }

  return time24h.join(''); // return adjusted time or original string
}

export const getTimeObjWithOffset = (dateObj, timeZoneOffset) => {
  return new Date(dateObj.getTime() + (timeZoneOffset + dateObj.getTimezoneOffset()) * 1000 * 60)
}


export const testAmPm = (val) => {
  const regexAmPm = /^([0]?[1-9]|1[0-2]):([0-5]\d)\s?(AM|PM)$/i;
  return regexAmPm.test(val)
}

export const test24 = (val) => {
  const regex24 = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
  return regex24.test(val)
}

export const getDateAsString = (date) => {
  return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
}

export const getDateTimeAsString = (date) => {
  return getDateAsString(date) + 'T' + String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0');
}
const MsInDay = 86400000;

export const iterateBetweenDates = (startDate, endDate, callBack, intervalInMs = MsInDay) => {
  let startDateMs = +new Date(startDate)
  const endDateMs = +new Date(endDate)
  for (let i = startDateMs; i <= endDateMs; i += intervalInMs) {
    callBack(i)
  }
}

export const mapBetweenDates = (startDate, endDate, format = "YYYY-MM-DD") => {
  const res = []
  const isFormatAFunction = typeof format === 'function'
  iterateBetweenDates(startDate, endDate, (currMs) => {
    const formatted = isFormatAFunction ? format(currMs) : moment(currMs).format(format)
    res.push(formatted)
  })
  return isFormatAFunction ? res : [...new Set(res)]
}
